import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { reputationLevelSelectors } from '@panel/core/src/state/ducks/reputationLevel';
import { sendCustomTrackingInfo } from '../../sendTrackingInfo';
import StepIndicator from './StepIndicator';
import { getDevice } from '../../../helpers';
import Step1 from './Step1';
import { ContainerModal, NavigationButtons, Button } from './styles';

const ReputationLevelModal = ({ onClose, userLoggedId, pathname }) => {
  const { t } = useTranslation();
  const device = getDevice();
  const [step, setStep] = useState(1);
  const { levelValue } = useSelector(reputationLevelSelectors.reputationLevelState);
  const TOTAL_STEPS = 1;

  const handleNextStep = () => {
    setStep(prevStep => Math.min(prevStep + 1, TOTAL_STEPS));
  };

  const handlePrevStep = () => {
    setStep(prevStep => Math.max(prevStep - 1, 1));
  };

  const handleFinishOnboarding = () => {
    onClose(false);
    if (!pathname.includes('estadisticas')) {
      window.open('/panel/estadisticas?tab=score', '_self');
    }
  };

  useEffect(() => {
    sendCustomTrackingInfo({
      event: 'impression_modal',
      content_group: 'Panel',
      user_reputation: levelValue || '-',
      user_id: userLoggedId,
      modal_name: 'Modal presentacion Score'
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ContainerModal>
      {step === 1 && <Step1 levelValue={levelValue} device={device} />}
      {/* Descomentar cuando se implementen los siguientes steps
      {step === 2 && <Step2 />}
      {step === 3 && <Step3 />}
      */}

      <NavigationButtons>
        {step > 1 && (
          <Button data-panel='panel-prevButton' className='prev-button' onClick={handlePrevStep}>
            {t('panel.avisos.reputationLevelModal.cta.prev')}
          </Button>
        )}
        {step > 1 && <StepIndicator currentStep={step} totalSteps={TOTAL_STEPS} />}
        {step === 1 && (
          <Button
            data-panel='panel-startButton'
            onClick={TOTAL_STEPS === 1 ? handleFinishOnboarding : handleNextStep}
            className='start-button'
          >
            {t(`panel.avisos.reputationLevelModal.cta.${levelValue === 5 ? 'alto' : 'bajo'}`)}
          </Button>
        )}
        {step > 1 && step < TOTAL_STEPS && (
          <Button data-panel='panel-nextButton' onClick={handleNextStep}>
            {t('panel.avisos.reputationLevelModal.cta.next')}
          </Button>
        )}
        {step > 1 && step === TOTAL_STEPS && (
          <Button data-panel='panel-endButton' onClick={handleFinishOnboarding}>
            {t('panel.avisos.reputationLevelModal.cta.end')}
          </Button>
        )}
      </NavigationButtons>
    </ContainerModal>
  );
};

ReputationLevelModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  userLoggedId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  pathname: PropTypes.string.isRequired
};

export { ReputationLevelModal };
